"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverRender = serverRender;
exports.clientRender = clientRender;
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _googleMap = babelHelpers.interopRequireDefault(require("google-map"));

var _decorators = require("decorators");

var _emailSignup = babelHelpers.interopRequireDefault(require("email-signup"));

var _class, _descriptor, _temp;

var Buttons = function Buttons(props) {
  return _react.default.createElement("div", {
    className: ClassList.join("button-list", props.className)
  }, props.children);
};

var Button = function Button(props) {
  return _react.default.createElement("button", {
    className: ClassList.join("btn", props.className)
  }, props.children);
};

var LocationDetail = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(LocationDetail, _Component);

  function LocationDetail() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, LocationDetail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(LocationDetail)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "location", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.types = {
      facebook: 'Facebook',
      twitter: 'Twitter' // yelp: 'Yelp',
      // google: 'Google+'

    };
    return _this;
  }

  babelHelpers.createClass(LocationDetail, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var trim = function trim(value) {
        return value.replace(/^\s*/, '').replace(/\s*$/, '');
      };

      var adr = trim(this.location.address) + "\n" + trim(this.location.city) + " " + trim(this.location.state) + " " + trim(this.location.zip);
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "large-header location-detail",
        style: {
          backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, .0)), url(/admin/platform/plugins/com.sightworks.5.Channel.instance.marketing/resources/images/tpash-bg-ingroundPool-1200x788.jpg)'
        }
      }, _react.default.createElement(_googleMap.default, {
        address: adr,
        coordinates: null,
        image: this.location.image_name
      })), _react.default.createElement(_emailSignup.default, null), _react.default.createElement("div", {
        className: "body-content location-detail center col-md-12"
      }, _react.default.createElement("h2", {
        className: "bold"
      }, "The Pool & Spa House"), _react.default.createElement("h1", {
        className: "location-name uppercase"
      }, this.location.location), _react.default.createElement("h2", null, this.location.phone, _react.default.createElement("br", null), this.location.hours1, _react.default.createElement("br", null), this.location.hours2, _react.default.createElement("br", null), this.location.hours3), _react.default.createElement("button", {
        className: "btn btn-secondary primary",
        style: {
          marginTop: '20px'
        },
        onClick: this.getDirections
      }, "Get Directions"), _react.default.createElement("div", {
        className: "button-list social-list"
      }, Object.keys(this.types).map(function (key) {
        return _this2.location[key] ? _react.default.createElement("a", {
          className: "btn btn-social btn-social-".concat(key),
          key: key,
          href: _this2.location[key],
          title: _this2.types[key]
        }) : null;
      }))));
    }
  }, {
    key: "getDirections",
    value: function getDirections() {
      var trim = function trim(value) {
        return value.replace(/^\s*/, '').replace(/\s*$/, '');
      };

      var adr = trim(this.location.address) + "\n" + trim(this.location.city) + " " + trim(this.location.state) + " " + trim(this.location.zip); // https://maps.google.com/maps?saddr=Current+Location&daddr=21950%20SE%20Stark+Gresham+OR+97030&hl=en&z=12

      window.open('https://maps.google.com/maps?saddr=Current+Location&daddr=' + encodeURIComponent(adr) + '&hl=en&z=12', '_blank');
      return false;
    }
  }]);
  return LocationDetail;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "location", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "getDirections", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "getDirections"), _class.prototype)), _class);
exports.default = LocationDetail;

function serverRender(location) {
  location = JSON.parse(JSON.stringify(location));
  return "\n\t\t<div data-component='LocationDetail'>".concat(_server.default.renderToString(_react.default.createElement(LocationDetail, {
    location: location
  })), "</div>\n\t\t<script>\n\t\t\trequire('location-detail').clientRender(document.querySelector('[data-component=LocationDetail]'), ").concat(JSON.stringify(location), ");\n\t\t</script>\n\t");
}

function clientRender(root, location) {
  _reactDom.default.render(_react.default.createElement(LocationDetail, {
    location: location
  }), root);
}